"use client";

import { type CountdownSection_Fields } from "~/__generated__/graphql";
import Container from "~/components/Container";
import { useCountdown } from "~/lib/hooks/useCountdown";

export default function CountdownSection({ date }: CountdownSection_Fields) {
  const [days, hours, minutes, seconds] = useCountdown(
    new Date(date as string),
  );

  return (
    <section className="black-section bg-black">
      <Container containerClass="py-4 gap-5">
        <div className="grid grid-cols-4 rounded border-2 border-white text-white py-3">
          <div className=" flex flex-col items-center">
            <div className="text-4xl" suppressHydrationWarning >{days}</div>
            <div className="text-sm sm:text-base">DAYS</div>
          </div>
          <div className=" flex flex-col items-center border-l-2 border-white">
            <div className="text-4xl" suppressHydrationWarning >{hours}</div>
            <div className="text-sm sm:text-base">HOURS</div>
          </div>
          <div className=" flex flex-col items-center border-l-2 border-white">
            <div className="text-4xl" suppressHydrationWarning >{minutes}</div>
            <div className="text-sm sm:text-base">MINUTES</div>
          </div>
          <div className=" flex flex-col items-center border-l-2 border-white">
            <div className="text-4xl" suppressHydrationWarning >{seconds}</div>
            <div className="text-sm sm:text-base">SECONDS</div>
          </div>
        </div>
      </Container>
    </section>
  );
}
